import React from "react";
import GeneratingLoader from "../shared/GeneratingLoader";
import QuestionCard from "../shared/QuestionCard";
import { Trash2 } from "lucide-react";

const AIStep3_Generate = ({ questions, isLoading, onDeleteQuestion, onNext }) => {
  if (isLoading) {
    return <GeneratingLoader />;
  }

  if (questions.length === 0) {
    return (
      <div className="text-center py-16 space-y-2">
        <p className="dark:text-gray-400 text-textSecondary text-sm">
          No questions generated. Go back and try different topics.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center">
        <p className="text-sm dark:text-gray-300 text-textSecondary">
          <span className="font-semibold dark:text-white text-textPrimary">{questions.length}</span> questions generated
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {questions.map((question, index) => (
          <QuestionCard
            key={index}
            question={question}
            index={index}
            onDelete={() => onDeleteQuestion(index)}
          />
        ))}
      </div>

      <div className="flex justify-end pt-2">
        <button onClick={onNext} className="button px-6">
          <span>Next: Save Set →</span>
        </button>
      </div>
    </div>
  );
};

export default AIStep3_Generate;
